import Img from "../assets/images/image";
import Svg from "../assets/Svgs/Svg";

export const data = {
   headerMenus: [
      {
         id: 1,
         menuName: "About Us",
         link: "/about-us",
      },
      {
         id: 2,
         menuName: "Services",
         link: "/services",
         dropdownsWidth: 700,
         dropdowns: [
            {
               heading: "Project Development",
               link: "/project-development",
               items: [
                  { link: "/web_app", name: "Web Development" },
                  { link: "/mobile_app", name: "Mobile App Development" },
                  { link: "/enterprise_app", name: "Enterprise Application" },
                  { link: "/design_development", name: "Design Development" },
                  { link: "/qa_testing", name: "QA & Testing" },
               ],
            },
            {
               heading: "Digital Marketing",
               link: "/digital-marketing",
               items: [
                  { link: "#contentMarketing", name: "Content Marketing" },
                  { link: "#socialMediaMarketing", name: "Social Media Marketing" },
                  { link: "#SeoContent", name: "SEO" },
                  {
                     link: "#ppcAdvertising",
                     name: "Pay-per-click (PPC) Advertising",
                  },
                  { link: "#emailMarketing", name: "Email Marketing" },
                  { link: "#marketStrategy", name: "Market Research and Strategy" },
               ],
            },

            {
               heading: "Staff Augmentation",
               link: "/staff_augmentation",
               items: [],
            },
         ],
      },
      {
         id: 3,
         menuName: "Industries",
         link: "/industries",
      },
      {
         id: 4,
         menuName: "Portfolio",
         link: "/portfolio",
      },
      {
         id: 5,
         menuName: "Products",
         link: "/products",
         dropdownsWidth: 400,
         dropdowns: [
            {
               link: "/../products",
               items: [
                  { link: "/shoppeez", name: "shoppeez" },
                  { link: "/g9_smart_menu", name: "g9 smart menu" },
               ],
            },
         ],
      },
      {
         id: 6,
         menuName: "Careers",
         link: "/career",
      },
      {
         id: 7,
         menuName: "Blogs",
         link: "/blogs",
      },
   ],

   counter: [
      {
         id: 1,
         count: 70,
         description: "Clients",
      },
      {
         id: 2,
         count: 100,
         description: "Projects",
      },
      {
         id: 3,
         count: 7,
         description: "Years of Experience",
      },
      {
         id: 4,
         count: 30,
         description: "Countries",
      },
      {
         id: 5,
         count: 120,
         description: "Team Members",
      },
   ],

   services: ["Mobile App Development--", "Web Development--", "Enterprise Application--", "Design Development--", "QA & Testing--", "Digital Marketing--"],

   servicesCarousel: [
      {
         id: 1,
         img: Img.webDevelopmentServices,
         title: "Web \n Development",
         desc: "We specialize in designing and creating websites tailored to meet the unique needs of your business. Utilizing best practices, we craft user-friendly and responsive websites that enhance the overall user experience. As a leading web development company, we are dedicated to delivering solutions that drive your business forward.",
         linkTo: "/services/project-development/web_app",
         isBlack: true,
      },
      {
         id: 2,
         img: Img.mobileAppDevelopmentServices,
         title: "Mobile App \n Development",
         desc: "Looking for a mobile app development company? You can get your business application on your smartphones, with innovative UI/UX designs. We provide mobile apps that support both, android as well as IOS.",
         linkTo: "/services/project-development/mobile_app",
         isBlack: false,
      },
      {
         id: 3,
         img: Img.enterpriseAppServices,
         title: "Enterprise \n Application",
         desc: "At Witmates, you’ll get a customized application to offer you scalability, integrity, and security into your system to improve your efficiency. From ERP to CRM, Witmates Technologies help you empower your business in the digital age.",
         linkTo: "/services/project-development/enterprise_app",
         isBlack: false,
      },
      {
         id: 4,
         img: Img.designDevelopmentServices,
         title: "Design \n Development",
         desc: "We specialize in crafting engaging and innovative UI/UX designs that elevate your digital presence and resonate success with your target audience. Our goal is to develop high-performing interfaces that deliver a delightful user experience.",
         linkTo: "/services/project-development/design_development",
         isBlack: true,
      },
      {
         id: 5,
         img: Img.qaAndTestingServices,
         title: "QA & \n Testing",
         desc: "When it comes to QA & testing, trust us to ensure your software meets the highest standards of performance, reliability, and user experience. Our dedicated QA & testing professionals drive excellence in every project, guiding your success towards perfection.",
         linkTo: "/services/project-development/qa_testing",
         isBlack: false,
      },
      {
         id: 6,
         img: Img.digitalMarketingServices,
         title: "Digital \n Marketing",
         desc: "Our digital marketers help you grow your business by driving organic traffic to your website, assist you with SEO ( search engine optimization ), running ad campaigns and many other techniques to improve your online visibility.",
         linkTo: "/services/digital-marketing",
         isBlack: true,
      },
   ],

   digitalSolutions: [
      {
         id: 1,
         title: "Mobile App \n Development",
         description:
            "Our team excels in creating cross-platform mobile applications that will make your business stand out from the competition. We understand the importance of user-friendliness and engagement, ensuring that your app provides a wonderful user experience.",
         img: Img.mobileAppDevelopment,
         linkTo: "/services/project-development/mobile_app",
      },
      {
         id: 2,
         title: "Web \n Development",
         description:
            "We specialize in crafting flawless web experiences used by millions of people. Our expertise lies in building responsive websites and progressive web applications that work seamlessly across devices. With our solutions, you can reach a wider audience and enhance your online presence.",
         img: Img.webDevelopment,
         linkTo: "/services/project-development/web_app",
      },
      {
         id: 3,
         title: "Enterprise \n Application",
         description:
            "We develop custom applications for enterprises that can scale, integrate with their systems, and perform exceptionally well. Our focus is on creating reliable, secure, and robust applications that cater to your specific requirements.",
         img: Img.enterpriseApp,
         linkTo: "/services/project-development/enterprise_app",
      },
      {
         id: 4,
         title: "Design \n Development",
         description:
            "We are dedicated to developing high-performing user interfaces that offer delightful and enduring user experiences for every digital interaction. Our UI/UX Design and Development services ensure that your digital presence is visually appealing and user-friendly.",
         img: Img.designDevelopment,
         linkTo: "/services/project-development/design_development",
      },
      {
         id: 5,
         title: "QA & Testing",
         description:
            "At Witmates, we have a skilled team of QA testers who perform comprehensive software testing procedures. Our reliable QA testing services incorporate a wide range of criteria, ensuring that your software is trouble-free and meets the highest quality standards.",
         img: Img.qaAndtesting,
         linkTo: "/services/project-development/qa_testing",
      },
   ],

   journeyList: [
      {
         id: 1,
         title: "(2018): The Beginning",
         description: [
            "Founded by three passionate tech enthusiasts, Witmates Technologies embarked on its mission.",
            "Started with a few small projects, laying the foundation for our future growth.",
         ],
         svg: Svg.numbers.one,
      },
      {
         id: 2,
         title: "(2019): Expanding Horizons",
         description: ["The team expanded to 10-15 like-minded individuals.", "Acquired a significant number of projects."],
         svg: Svg.numbers.two,
      },
      {
         id: 3,
         title: "(2020): Thriving Amidst Challenges",
         description: [
            "Despite the global lockdown, our determination remained unwavering.",
            "Leveraged our passion and expertise to achieve remarkable growth.",
            "The team grew to 50+ passionate developers.",
         ],
         svg: Svg.numbers.three,
      },
      {
         id: 4,
         title: "(2023): Driving Success",
         description: [
            "A team of over 120 individuals successfully completed more than 100 projects,",
            "Reached in 30+ countries.",
            "Achieved the prestigious CMMI L-5 certification",
            "Attained ISO 27001 certification",
         ],
         svg: Svg.numbers.four,
      },
   ],
   newJourneyList: [
      {
         id: 1,
         year: 2024,
         title: "Driving #color:Success",
         descriptions: [
            {
               row: [
                  "Now today, we are an innovative and talented team of 100+ staff, like minded people and have successfully served in 100+ projects. We have attained prestigious certification of ISO 2700 and CMMI L-5 certification in the year 2023. We are honored to participate in the ‘  INDIA SOFT EVENT ‘ which is held in New Delhi ( India ).",
               ],
            },
         ],
      },
      {
         id: 2,
         year: 2020,
         title: "Thriving Amidst #color:Challenges",
         descriptions: [
            {
               row: ["Even amidst challenging conditions like lockdowns, the company's unwavering faith and resilience shine through, appreciating employees for their dedication and shared goals."],
            },
         ],
      },
      {
         id: 3,
         year: 2019,
         title: "Expanding #color:Horizons",
         descriptions: [
            {
               row: ["The company achieved recognition and consolidated its position with clients, completing numerous projects and expanding its team to include 10-15 tech specialists."],
            },
         ],
      },
      {
         id: 4,
         year: 2018,
         title: "The #color:Beginning",
         descriptions: [
            {
               row: ["Founded by three tech enthusiasts, Sonu Singh Bhadouria, Shakti Katare, and Prashant Jatav."],
            },
            {
               row: ["Their passion pioneered industry standards and propelled the company toward success."],
            },
         ],
      },
   ],
   rewardsAndRecognition: [
      {
         id: 1,
         rewardName: "Iso 27001 certified company",
         rewardImg: Img.reward1,
      },
      {
         id: 2,
         rewardName: "CMMI ML-5 certified company",
         rewardImg: Img.reward2,
      },
      {
         id: 3,
         rewardName: "upwork",
         rewardImg: Img.reward3,
      },
      {
         id: 4,
         rewardName: "clutch",
         rewardImg: Img.reward4,
      },
   ],
   chooseUs: [
      {
         id: 1,
         title: "Certified Professionals",
         img: Img.chooseus1,
         description:
            "As an IT staff augmentation company, we feature highly skilled developers who are certified and proficient in their respective fields, and continuously updated with the latest technologies.",
      },
      {
         id: 2,
         title: "Timely Delivery",
         img: Img.chooseus2,
         description:
            "We excel in meeting deadlines! Our commitment is to deliver your projects on time and with impeccable quality. We prioritize delivering high-quality content to ensure your satisfaction.",
      },
      {
         id: 3,
         title: "High-Caliber Recruitment",
         img: Img.chooseus3,
         description: "Championing excellence in every project, we recruit highly qualified individuals with relevant experience and skills into our team.",
      },
      {
         id: 4,
         title: "Zero cost project managers",
         img: Img.chooseus4,
         description: "At Witmates Technologies, we pride ourselves on offering systematic project management solutions that prioritize transparency and efficiency without any hidden cost.",
      },
   ],
   testimonials: [
      {
         id: 1,
         review:
            "My company (Codenia Technologies LLP) hired a couple of developers from Sonu Singh's team (Witmates Technologies) on a contract basis, the developers really did a great  job, they were very much responsive, Technically very strong, fluent in communication, my client was very much happy with their work, I will definitely hire the developers from this team for my upcoming projects and highly recommend too!!",
         clientName: "Soumya Chauhan",
         location: "From USA",
         img: Img.usertestimonial,
      },

      {
         id: 2,
         review:
            "We started with a small project a year ago with Sonu and his team, as we move on and with fabulous jobs done we deal on a big project. It’s all about commitment to the work, smooth work culture, timely and quality deliverance, quick responses and fluent communication of Witmates guys make remote jobs much easier. I will continue to work with them & highly recommend this team.",
         clientName: "David Kolak",
         location: "India",
         img: null,
      },

      {
         id: 3,
         review: "Prashant is a competent back-end guy. Would be looking to get him to deliver some specific tasks when they arise in the future. Thanks Prashant for everything to date.",
         clientName: "Scott Miller",
         location: "UK",
         img: null,
      },
      {
         id: 4,
         review: "Shakti did a great job and meet most of the deliverables thought out the engagement on this project, we will definitely use him again for any future work.",
         clientName: "Basant Verma",
         location: "UK",
         img: null,
      },
   ],

   industryList: [
      {
         id: 1,
         title: "Logistics Software \n Development",
         description:
            "We provide cutting-edge software solutions to optimize supply chain operations, streamline inventory management, and enhance logistics processes. We ensure seamless operations and cost efficiency for your logistics business.",
         image: Img.industry1,
      },
      {
         id: 2,
         title: "Asset Tracking \n Software",
         description:
            "With our advanced technology, we provide real-time asset tracking and monitoring software, empowering your business to effectively manage and secure your valuable assets, whether it's fleet vehicles, equipment, or high-value inventory.",
         image: Img.industry2,
      },
      {
         id: 3,
         title: "Event \n Management",
         description:
            "With our comprehensive event management software, you can effortlessly plan, coordinate, and execute successful events, from ticketing and registration to attendee engagement. Also, post-event analytics will enable you to manage your costs and drive more growth and profits.",
         image: Img.industry3,
      },
      {
         id: 4,
         title: "Media & \n Entertainment",
         description:
            "Our innovative software solutions revolutionize the way media and entertainment content is managed and delivered. From content creation and distribution to audience engagement, our technology empowers you to deliver immersive experiences to your audiences.",
         image: Img.industry4,
      },
      {
         id: 5,
         title: "Transportation",
         description:
            "We provide transportation software solutions to optimize fleet management, route planning, and logistics operations. Providing smooth operations, cost savings, and improved customer satisfaction, our technology drives efficiency and effectiveness across the transportation sector.",
         image: Img.industry5,
      },
      {
         id: 6,
         title: "Automobile \n Industry",
         description:
            "We provide innovative and efficient software solutions to streamline the evolving needs of the automobile industry. With features ranging from efficient inventory management and streamlined dealership operations to robust customer relationship management systems, we empower the automotive sector to drive growth.",
         image: Img.industry6,
      },
      {
         id: 7,
         title: "Insurance \n Technologies",
         description:
            "Our advanced software solutions empower the insurance industry by automating those complex processes and enabling seamless digital interactions with customers. Plus, our technology provides valuable data-driven insights that help assess risks and make smarter decisions.",
         image: Img.industry7,
      },
      {
         id: 8,
         title: "Banking & \n Finance",
         description:
            "With our advanced technology, we provide robust security and scalability, enabling financial institutions to streamline their operations, provide exceptional customer experiences, and enable hassle-free online transactions.",
         image: Img.industry8,
      },
      {
         id: 9,
         title: "Trading \n Software",
         description:
            "We develop high-performance trading software that empowers traders and financial institutions with advanced tools for market analysis, algorithmic trading, risk management, and trade execution. Our advanced technology enables traders to gain a competitive edge in the fast-paced trading world.",
         image: Img.industry9,
      },
      {
         id: 10,
         title: "Healthcare & \n Fitness",
         description:
            "We cater to the healthcare and fitness sectors with our advanced software solutions, facilitating advanced features like electronic health records, telemedicine services, appointment scheduling, fitness tracking, and wellness program management. We are helping the sector to improve patient care and promote healthy lifestyles.",
         image: Img.industry10,
      },
      {
         id: 11,
         title: "E-commerce",
         description:
            "Our software solutions are the ultimate game-changers for E-commerce businesses. We enable businesses to create robust online stores, manage product catalogues, process secure transactions, and provide personalized shopping experiences. With our software, you'll drive growth, boost customer satisfaction, and conquer the digital marketplace.",
         image: Img.industry11,
      },
      {
         id: 12,
         title: "Real Estate",
         description: `We provide the real estate industry with CRM, property management, and accounting software. It helps track client interactions, manage leads, and build healthy owner-tenet relationships. With our software, you can track rent collection and optimize expenses.`,
         image: Img.industry12,
      },
   ],

   portfolioList: [
      {
         id: 1,
         title: "Owner operator movers",
         img: Img.owneroperator,
         appType: "Web App",
      },
      {
         id: 2,
         title: "Groovepacker",
         img: Img.groovepacker,
         appType: "Web App",
      },
      {
         id: 3,
         title: "HelpfulCrowd",
         img: Img.helpfulcrowd,
         appType: "Web App",
      },
      {
         id: 4,
         title: "Bookamove",
         img: Img.bookamove,
         appType: "Web App",
      },
      {
         id: 5,
         title: "Bloom",
         img: Img.bloom,
         appType: "Web App",
      },
      {
         id: 6,
         title: "Graftek Imaging",
         img: Img.graftekimaging,
         appType: "Web App",
      },
      {
         id: 7,
         title: "Brosa",
         img: Img.brosa,
         appType: "Web App",
      },
      {
         id: 8,
         title: "SYNCrew",
         img: Img.syncrew,
         appType: "Web App",
      },
      {
         id: 9,
         title: "PosiWise",
         img: Img.posiwise,
         appType: "Web App",
      },
      {
         id: 10,
         title: "MiniMove",
         img: Img.minimove,
         appType: "Web App",
      },
      {
         id: 11,
         title: "Getdispatchbot",
         img: Img.getdispatchbot,
         appType: "Web App",
      },
      {
         id: 12,
         title: "On Track",
         img: Img.ontrack,
         appType: "Web App",
      },
      {
         id: 13,
         title: "G9 SmartMenu ( Web App)",
         img: Img.g9smartmenu1,
         appType: "G9 SmartMenu",
      },
      {
         id: 14,
         title: "G9 SmartMenu ( Mobile App)",
         img: Img.g9smartmenu2,
         appType: "G9 SmartMenu",
      },
      {
         id: 15,
         title: "Shoppeez",
         img: Img.shoppeez,
         appType: "Shoppeez",
      },
   ],

   factors: [
      {
         id: 1,
         title: "Extensive \n Network:",
         description: "We have a wide network of clients from all over the world, serving them with our top notch mobile development, web design, web development, staff augmentation, QA  testing and digital marketing services for over 5+ years in the market.",
         image: Img.factors1,
      },
      {
         id: 2,
         title: "High Customer \n Retention:",
         description: "We actively seek feedback from customers to continuously improve our services. At Witmates Technologies, we prioritize building transparent, long-term relationships with our customers.",
         image: Img.factors2,
      },
      {
         id: 3,
         title: "Post-development \n Support:",
         description: "We not only help you develop a reliable solution, but we also provide maintenance support after deployment.",
         image: Img.factors3,
      },
      {
         id: 4,
         title: "Timely \n Delivery:",
         description: "We deliver your projects efficiently on time without compromising the quality, Our dedicated team ensures to fulfill your needs and demands with satisfaction and success.",
         image: Img.factors4,
      },
      {
         id: 5,
         title: "Cutting-edge \n Technologies:",
         description: "We stay ahead of competitors by continuously upgrading with the latest tools and techniques. Our experts ensure that your solutions are always at the forefront of innovation.",
         image: Img.factors5,
      },
      {
         id: 6,
         title: "Competitive \n Pricing:",
         description: "We prioritize cost-effective solutions for our customers, ensuring they consistently receive value and affordability. We strive to tailor our services to accommodate flexible budgets and specific requirements.",
         image: Img.factors6,
      },
   ],
   g9services: [
      {
         id: 1,
         title: "Contactless ordering \n for multi course dinning",
         description:
            "G9 smart menu provides the Best User Friendly QR code based Digital Food ordering system without downloading any Android/iOS App in Guest's Mobile. QR Code based System provides the available Food Item list along with the quantity and price in Customer Mobile and then select/search item to make the cart for order.",
         image: Img.g9services1,
      },
      {
         id: 2,
         title: "Serve captain \n app",
         description:
            "Our Android application empowers the server to take orders directly at the table and generate a KOT (Kitchen Order Ticket) instantly. By eliminating manual processes, it saves time and enhances the customer experience. The captain app offers a range of advanced features for efficient table management in your restaurant.",
         image: Img.g9services2,
      },
      {
         id: 3,
         title: "Less Spent \n optimize services",
         description:
            "Reduce staff expenditure by 40 to 50% through staff reduction. Eliminate the need for printing menus, saving money. Avoid printing flyers, specials, and similar materials, resulting in cost savings. Customer can make the payment online and offline both mode. Admin and Customer get notified by SMS notification when any order placed.",
         image: Img.g9services3,
      },
   ],
   shoppeezServices: [
      {
         id: `shoppeez-services-${1}`,
         title: "Value for Money",
         description:
            "Shoppeez isn’t just another e-commerce platform; we invest in your business's success. Our affordable pricing plans cater to every budget, allowing you to focus on your business. And with our commitment to continuous improvement, your investment is always worthwhile.",
         image: Img.shoppeezService1,
      },
      {
         id: `shoppeez-services-${2}`,
         title: "User-\n Friendliness",
         description:
            "We believe that e-commerce should be easy, not a hassle. That's why we've designed Shoppeez with you in mind. Our intuitive interface and user-friendly tools make it easy to create your online store and manage your business. No coding or technical expertise required.",
         image: Img.shoppeezService2,
      },
      {
         id: `shoppeez-services-${3}`,
         title: "Integrated \n POS System",
         description:
            "Shoppeez's built-in POS system seamlessly connects your online and offline sales, giving you a complete picture of your business. Track inventory, manage customer orders, and accept payments – all from a single, centralized hub.",
         image: Img.shoppeezService3,
      },
   ],
   serviceDifferentList: [
      {
         id: 1,
         title: "Enhanced User \n Experience",
         description: "We focus on creating intuitive and user-friendly websites that provide a seamless browsing experience.",
      },
      {
         id: 2,
         title: "Customized  \n toYour Brand",
         description: "We ensure that your website is fully responsive and compatible with various screen sizes and devices.",
      },
      {
         id: 3,
         title: "Enhanced Security \n and Data Protection",
         description: "We implement robust security measures, follow industry best practices, and ensure compliance with data protection regulations.",
      },
      {
         id: 4,
         title: "Scalable and \n Flexible Solutions",
         description: "Our web development services are designed to meet your current needs while providing room for future growth.",
      },
   ],
   leaders: [
      {
         id: 1,
         img: Img.leader1,
         name: "Sonu Singh Bhadouria",
         designation: "CEO, Co-founder",
         linkedin: "https://www.linkedin.com/in/sonu-singh-ror/",
      },
      {
         id: 2,
         img: Img.leader2,
         name: "Shakti Katare",
         designation: "CTO, Co-founder",
         linkedin: "https://www.linkedin.com/in/shakti-katare-852901a6/ ",
      },
      {
         id: 3,
         img: Img.leader3,
         name: "Prashant Jatav",
         designation: "CEO, Co-founder",
         linkedin: "https://www.linkedin.com/in/prashant-jatav/",
      },
   ],

   jobList: [
      {
         id: 1,
         title: "Python Developer",
         experience: "3+ Years",
      },
      {
         id: 2,
         title: "Devops Engineer",
         experience: "3+ Years",
      },
      {
         id: 3,
         title: "Dot Net",
         experience: "3+ Years",
      },
      {
         id: 4,
         title: "Java developer",
         experience: "3+ Years",
      },
      {
         id: 5,
         title: "Ruby on Rails developer",
         experience: "3+ Years",
      },
      {
         id: 6,
         title: "Nodejs Developer",
         experience: "1-6 Years",
      },
      {
         id: 7,
         title: "Graphic Designer",
         experience: "3+ Years",
      },
   ],

   footerLinks: [
      {
         id: 1,
         name: "Home",
         linkto: "/",
      },
      {
         id: 2,
         name: "About Us",
         linkto: "/about-us",
      },
      {
         id: 3,
         name: "Project Development",
         linkto: "/services/project-development",
      },
      {
         id: 4,
         name: "Industries",
         linkto: "/industries",
      },
      // {
      //    id: 5,
      //    name: "Case Studies",
      //    linkto: "",
      // },
      {
         id: 6,
         name: "Careers",
         linkto: "/career",
      },
      {
         id: 7,
         name: "Contact US",
         linkto: "/get-in-touch",
      },
   ],

   footerServices: [
      {
         id: 1,
         name: "Project Development",
         linkto: "/services/project-development",
      },
      {
         id: 2,
         name: "Digital Marketing",
         linkto: "/services/digital-marketing",
      },
      {
         id: 3,
         name: "Staff Augmentation",
         linkto: "/services/staff_augmentation",
      },
      {
         id: 4,
         name: "Web Development",
         linkto: "/services/project-development/web_app",
      },
      {
         id: 5,
         name: "Mobile App Development",
         linkto: "/services/project-development/mobile_app",
      },
      {
         id: 6,
         name: "Enterprise Application",
         linkto: "/services/project-development/enterprise_app",
      },
      {
         id: 7,
         name: "Design Development",
         linkto: "/services/project-development/design_development",
      },
      {
         id: 8,
         name: "QA & Testing",
         linkto: "/services/project-development/qa_testing",
      },
   ],

   trustedBy: [
      {
         icon: Svg.clients,
         heading: "70+",
         subHeading: "Clients",
      },
      {
         icon: Svg.projects,
         heading: "100+",
         subHeading: "Projects",
      },
      {
         icon: Svg.experience,
         heading: "5+",
         subHeading: "Years of experience",
      },
      {
         icon: Svg.certified,
         heading: "Certified",
         subHeading: "CMMI Level 5 Company",
      },
      {
         icon: Svg.teamMembers,
         heading: "120+",
         subHeading: "Team members",
      },
      {
         icon: Svg.professionals,
         heading: "Certified",
         subHeading: "Professionals",
      },
      {
         icon: Svg.countries,
         heading: "30+",
         subHeading: "Countries",
      },
      {
         icon: Svg.iso,
         heading: "ISO",
         subHeading: "27001 Certification",
      },
      {
         icon: Svg.establishment,
         heading: "2018",
         subHeading: "Year Of Establishment",
      },
      {
         icon: Svg.clientCentric,
         heading: "Client-Centric",
         subHeading: "Approach",
      },
      {
         icon: Svg.onTimeDelivery,
         heading: "100%",
         subHeading: "On-time Delivery",
      },
      {
         icon: Svg.customerSupport,
         heading: "24/7",
         subHeading: "Customer Support",
      },
   ],

   contactUs: [
      {
         type: "address",
         icon: Img.gps,
         title: "Address",
         description: "712-713, Princess Business Skypark Opposite Orbit Mall, AB Rd, Indore, Madhya Pradesh 452010",
      },
      {
         type: "email",
         icon: Img.email,
         title: "Send Us an Email",
         description: "sales@witmates.com",
      },
      {
         type: "phone",
         icon: Img.phoneCall,
         title: "Give Us a Call",
         description: "+91-888-991-1196",
      },
   ],

   webDevelopmentData: [
      {
         id: 1,
         title: "Enhanced User \n Experience",
         description: "We focus on creating intuitive and user-friendly websites that provide a seamless browsing experience.",
      },
      {
         id: 2,
         title: "Customized  \n toYour Brand",
         description: "We ensure that your website is fully responsive and compatible with various screen sizes and devices.",
      },
      {
         id: 3,
         title: "Enhanced Security \n and Data Protection",
         description: "We implement robust security measures, follow industry best practices, and ensure compliance with data protection regulations.",
      },
      {
         id: 4,
         title: "Scalable and \n Flexible Solutions",
         description: "Our web development services are designed to meet your current needs while providing room for future growth.",
      },
   ],
   appDevelopmentData: [
      {
         id: 1,
         title: "User-Centric \n Approach",
         description: "By prioritizing user-centricity, we create mobile apps that truly resonate with your audience and deliver exceptional user experiences.",
      },
      {
         id: 2,
         title: "Seamless \n Integration and \n Scalability",
         description:
            "We prioritize seamless integration and scalability in our development process, enabling you to effortlessly integrate with existing systems and ensuring the ability to accommodate future growth.",
      },
      {
         id: 3,
         title: "Cutting-Edge \n Technologies and \n Innovation",
         description:
            "We leverage cutting-edge tools and frameworks to create innovative and high-performing mobile apps. Our developers are constantly exploring new possibilities to enhance your app's functionality, security, and user engagement.",
      },
      {
         id: 4,
         title: "Post-Launch \n Support and \n Maintenance ",
         description:
            "Even after the launch of your amazing app, our relationship doesn’t end. We provide comprehensive post-launch support and maintenance services to ensure your app's long-term success.",
      },
   ],
   enterpriseApplicationData: [
      {
         id: 1,
         title: "Enterprise-Level \n Expertise",
         description:
            " We specialize in solving complex enterprise problems, developing customized applications that seamlessly integrate with existing systems and handle large-scale data management.",
      },
      {
         id: 2,
         title: "Scalability and \n Performance",
         description: "We build applications that scale effortlessly with your business, ensuring top-notch performance even under high data volumes and demanding transactions.",
      },
      {
         id: 3,
         title: "Robust Security \n Measures",
         description: "We prioritize robust security measures to protect your sensitive data, ensuring compliance with industry regulations and protecting against security threats.",
      },
      {
         id: 4,
         title: "Comprehensive \n Support",
         description: "We provide comprehensive support and maintenance services to ensure the continuous performance and longevity of your enterprise application.",
      },
   ],
   designDevelopmentData: [
      {
         id: 1,
         title: "User-Centric \n Design Thinking",
         description: "We are driven by a user-centric design approach, thoughtfully crafting interfaces that prioritize the needs and desires of your users.",
      },
      {
         id: 2,
         title: "Seamless \n Integration with \n Enterprise Systems",
         description: "We specialize in integrating our UI/UX designs seamlessly with your existing enterprise systems.",
      },
      {
         id: 3,
         title: "Customized \n Solutions for \n Complex Workflows",
         description: "Our customized web design development services solutions are tailor made simplify and enhance these complex workflows, providing intuitive interfaces.",
      },
      {
         id: 4,
         title: "Reliable Support \n and Maintenance",
         description: "We provide comprehensive support and maintenance services to ensure your UI/UX design remains optimal and up-to-date.",
      },
   ],
   QaTestingData: [
      {
         id: 1,
         title: "Robust Testing \n Methodologies",
         description: "We use industry best practices, advanced tools, and a comprehensive approach to ensure thorough testing and uncompromising quality.",
      },
      {
         id: 2,
         title: "Domain \n Expertise",
         description: "Our team of QA experts possesses deep domain knowledge across various industries that allows us to implement testing strategies for your specific industry.",
      },
      {
         id: 3,
         title: "Collaborative \n Partnership",
         description: "We work closely with you throughout the testing process, involving you in decision-making and providing transparent communication at every step.",
      },
      {
         id: 4,
         title: "Reliable Support \n and Maintenance",
         description: "We offer comprehensive support and maintenance services to ensure your software remains in peak condition.",
      },
   ],
   staffAugmentationData: [
      {
         id: 1,
         title: "On-demand \n Top Talent",
         description:
            "We have an extensive in-house network of talented IT professionals with diverse skill sets and industry experience. So, we quickly identify and deploy the right experts for your project.",
      },
      {
         id: 2,
         title: "Client-Centric \n Approach",
         description:
            "We understand and prioritize unique business needs and project requirements. We work closely with you to define the ideal skill set, experience level, and ideal fit for the professionals you require.",
      },
      {
         id: 3,
         title: "Proven Track \n Record",
         description:
            "With years of experience in the IT industry, we have successfully successfully catered skilled IT  staff augmentation services to numerous clients across various sectors. We aim to provide top-notch talent and contribute to the success of our clients' projects.",
      },
      {
         id: 4,
         title: "Ongoing \n Support",
         description:
            "We provide continuous support and ensure effective communication throughout the project because we believe in maintaining strong relationships with our clients even after the professionals are onboarded.",
      },
   ],
   digitalMarketingData: [
      {
         id: 1,
         title: "Personalized \n Approach",
         description: "We first understand your business thoroughly, then we create a customized digital marketing strategy for the unique needs of your business.",
      },
      {
         id: 2,
         title: "Data-Driven \n Insights",
         description:
            "We leverage the power of data and ensure that every penny is spent wisely, targeting the right audience, at the right time, with the right message, resulting in exceptional growth.",
      },
      {
         id: 3,
         title: "Creative \n Storytelling",
         description:
            "We don't just market, we captivate. Our team of creative minds knows how to tell your brand's story in a way that grabs attention and builds emotional connections with your audience.",
      },
      {
         id: 4,
         title: "Transparent \n Collaboration:",
         description:
            "We believe in transparency and open collaboration. Throughout our partnership, we provide regular updates, detailed reports, and clear communication, ensuring you're always in the know about the progress and results of your digital marketing campaigns.",
      },
   ],
   witmatesEvents: [
      {
         bannerImage: Img.witmatesEvents.event1,
      },
      {
         bannerImage: Img.witmatesEvents.event2,
      },
   ],
};
